export default {
  metadata: {
    version: 1.0,
    langTag: 'fr',
    langFamily: 'French',
    langVariant: 'French',
    supportedLanguages: ['English', 'French'],
  },

  langText: {
    newUserInquiry: 'Nouvel utilisateur?',
    signupLink: "S'inscrire",
    contactSupport: 'Contactez le support',
    rightReserved: 'Tous droits réservés © 2021 SeamID',
    privacyTerm: 'Intimité | termes',
    appName: 'SeamID',
    organizationName: 'SEAMFIX',
    carouselHeader1: 'La banane que vous aimez',
    carouselHeader2: 'Mickey mouse sourit toujours',
    carouselHeader3: 'Mickey et ses amis',
    carouselText1:
      "hey rappelez-vous quand nous avons parlé d'une bonne banane",
    carouselText2:
      "depuis le jour où j'ai rencontré mickey mouse j'ai toujours souri",
    carouselText3:
      'Ceci est mes amis, nous avons tous un temps fou tous les jours',
    signinText: 'Se connecter',
    loginConfigEmailAddressLabelKey: "Entrer l'adresse",
    loginConfigEmailAddressPlaceholderKey: "Entrer l'adresse e-mail",
    loginConfigEmailInvalidKey: "L'email n'est pas valide",
    loginConfigEmailRequiredKey: "L'email est requis",
    loginConfigEmailLengthKey:
      'Courriel trop court, doit être de 5 caractères et plus',

    loginConfigUsernameAddressLabelKey: "Nom d'utilisateur",
    loginConfigUsernameAddressPlaceholderKey:
      "Saisissez votre nom d'utilisateur",
    loginConfigUsernameInvalidKey: "Le nom d'utilisateur n'est pas valide",
    loginConfigUsernameRequiredKey: "Nom d'utilisateur est nécessaire",
    loginConfigUsernameLengthKey:
      "La longueur du nom d'utilisateur est trop courte, doit être de 2 caractères et plus",
    loginConfigPhoneAddressLabelKey: 'Numéro de téléphone',
    loginConfigPhoneAddressPlaceholderKey: 'Entrez le numéro de téléphone',
    loginConfigPhoneInvalidKey: "Le numéro de téléphone n'est pas valide",
    loginConfigPhoneRequiredKey: 'Numéro de téléphone est requis',
    loginConfigPhoneLengthKey:
      "Le numéro de téléphone n'est pas valide doit contenir 11 chiffres",
    loginConfigPhoneMaxLengthKey:
      'Numéro de téléphone trop court, doit être supérieur ou égal à 13 chiffres',

    loginConfigPasswordLabelKey: 'Mot de passe',
    loginConfigPasswordsPlaceholderKey: 'Entrer le mot de passe',
    loginConfigPasswordInvalidKey: 'Mot de passe non valide',
    loginConfigPasswordRequiredKey: 'Mot de passe requis',
    loginConfigPasswordLengthKey:
      'La longueur du mot de passe est trop courte, doit être de 5 caractères et plus, inclure un caractère spécial et un nombre',
    forgotPasswordConfigPhoneLabelKey: 'Numéro de téléphone',
    forgotPasswordConfigPhonePlaceholderKey: 'Entrez le numéro de téléphone',
    forgotPasswordConfigPhoneInvalidKey: 'Numéro de téléphone non valide',
    forgotPasswordConfigPhoneRequiredKey:
      'Votre numéro de téléphone est requis pour la réinitialisation du mot de passe',
    forgotPasswordConfigPhoneLengthKey:
      "Le numéro de téléphone n'est pas valide doit contenir 11 chiffres",

    forgotPasswordEmailAddressLabelKey: "Entrer l'adresse",
    forgotPasswordEmailAddressPlaceholderKey: "Entrer l'adresse e-mail",
    forgotPasswordEmailInvalidKey: "L'email n'est pas valide",
    forgotPasswordEmailRequiredKey: "L'email est requis",
    forgotPasswordEmailLengthKey:
      'Courriel trop court, doit être de 5 caractères et plus',

    regexAtleastOneDigit: 'Le mot de passe doit contenir au moins un chiffre',
    regexAtLeastOneLowercase:
      'Le mot de passe doit contenir au moins un minuscule',
    resetPasswordConfigPasswordLabelKey: 'Mot de passe',
    resetPasswordConfigPasswordPlaceholderKey: 'Entrer le mot de passe',
    resetPasswordConfigPasswordInvalidKey: 'Mot de passe non valide',
    resetPasswordConfigPasswordRequiredKey:
      'Le mot de passe est requis pour la réinitialisation du mot de passe',
    resetPasswordConfigPasswordLengthKey:
      "Le mot de passe n'est pas valide doit contenir 11 chiffres",

    resetPasswordFormSuccess: 'Le mot de passe a été changé avec succès',
    resetPasswordFormBackToSignIn: 'Retour pour vous connecter',
    resetPasswordFormHeader: 'réinitialiser le mot de passe',
    resetPasswordFormSetPasswordText: 'Définissez votre nouveau mot de passe',
    resetPasswordFormBtnText: 'réinitialiser le mot de passe',
    resetPasswordImageHeader: 'Le temps de changer',
    resetPasswordImageText: 'Créez un nouveau mot de passe pour votre compte.',

    forgetPasswordHeaderText: 'Mot de passe oublié',
    forgetPasswordEmailAddress:
      "Saisissez l'adresse e-mail associée à votre compte",
    forgetPasswordPhoneNumber:
      'Entrez le numéro de téléphone associé à votre compte',
    forgetPasswordAccount:
      "Entrez l'e-mail ou le numéro de téléphone associé à votre compte",
    forgetPasswordBtnText: 'réinitialiser le mot de passe',
    forgetPasswordImageHeader: 'Zut!',
    forgetPasswordImageText:
      'Mot de passe oublié? Réinitialisez-le rapidement en fournissant votre e-mail.',

    changePasswordFormHeader: 'Changer le mot de passe',
    changePasswordFormBtnText: 'Changer le mot de passe',
    changePasswordFormSetPasswordText:
      'Changer le mot de passe par défaut envoyé à votre email',

    resetLinkEmailHeader: 'Vérifiez votre boîte de réception',
    resetLinkPhoneHeader: 'Regarde tes messages',
    resetLinkEmailMessage:
      "Une réinitialisation du mot de passe a été envoyée à l'adresse e-mail ci-dessus. Veuillez cliquer sur le lien de réinitialisation du mot de passe dans l'e-mail pour définir un nouveau mot de passe",
    resetLinkPhoneMessage:
      'Une réinitialisation du mot de passe a été envoyée au numéro de téléphone ci-dessus. Veuillez cliquer sur le lien de réinitialisation du mot de passe dans le message pour définir un nouveau mot de passe',
    notYourEmail: 'Pas votre e-mail?',
    notYourPhoneNumber: 'pas votre numéro de téléphone',
    enterDifferentEmail: 'Entrez un autre courrier',
    enterDifferentPhoneNumber: 'Entrez un autre numéro de téléphone',
    needHelp: "Besoin d'aide?",

    resetOnLoginHeader: 'Le temps de changer',
    resetOnLoginEmailtext:
      "Nous avons mis à jour notre portail et vous devez modifier votre mot de passe. Un lien de réinitialisation du mot de passe a été envoyé à l'adresse e-mail ci-dessus.",
    resetOnLoginPhonetext:
      'Nous avons mis à jour notre portail et vous devez modifier votre mot de passe. Un lien de réinitialisation du mot de passe a été envoyé au numéro de téléphone ci-dessus.',
    gotoLogin: 'Aller à la connexion',

    successBannerMessage: 'le mot de passe est sécurisé et tout est réglé!',

    socialGoogleText: 'Connectez via Google',
    welcomeBack: 'Nous saluons le retour',
    signinToContinue: 'Connectez-vous pour continuer',
    troubleSigninInquiry: 'difficultés à se connecter?',
    forgetText: 'Mot de passe oublié?',
    otpConfirmBtn: 'Confirmer OTP',
    otpHeader: 'Entrez OTP',
    otpHeaderTextInit: 'Nous avons envoyé un ',
    otpHeaderTextFinal: 'code de confirmation à',
    otpNotSeen: "N'a pas reçu l'OTP?",
    resendOtp: 'Envoyer à nouveau',
    emailIsRequired: 'Email is required',
    usernameIsRequired: 'Username is required',
    passwordIsRequired: 'Password is required',
    prefixIsRequired: 'is required',
    emailPatternMessage:
      'Only include characters a-z & A-Z, Numbers 0-9, Symbols fullstop (.) hyphen (-) and underscore(_) and characters not less than 2 before the @ in your email address',
    passwordPatternMessage:
      'Length of password should not be less than 6 characters. No space allowed',
    usernamePatternMessage:
      'Should only contain Alphabet, Numbers and dashes(-). No space allowed and at least 3 character',
    fillFieldWarning: 'Please fill out this field',

    createUserHeading: 'Invitez des utilisateurs à Seamfix',
    createUserHeadingText:
      'Invitez vos collègues à vous rejoindre sur The Base pour collaborer sur des projets',
    createUserCheckboxtext: 'Créer un autre',
    createUserBtnText: 'Inviter',
    createUserConfigTitleLabelKey: 'Titre',
    createUserConfigTitlePlaceholderKey: 'Titre',
    createUserConfigTitleOptionKey1: 'Monsieur',
    createUserConfigTitleOptionKey2: 'Madame',
    createUserConfigTitleOptionKey3: 'Mademoiselle',
    createUserConfigTitleRequiredKey: 'Le titre est requis',
    createUserConfigFirstNameLabelKey: 'Prénom',
    createUserConfigFirstNamePlaceholderKey: 'Prénom',
    createUserConfigFirstNameRegexKey: 'Prénom non valide',
    createUserConfigFirstNameRequiredKey: 'Le prénom est requis',
    createUserConfigFirstNameLengthKey:
      'Longueur du prénom trop courte, doit être de 2 caractères et plus',
    createUserConfigFirstNameLengthKey2:
      'Longueur du prénom trop courte, ne doit pas dépasser 50 caractères',
    createUserConfigLastNameLabelKey: 'Nom de famille',
    createUserConfigLastNamePlaceholderKey: 'Nom de famille',
    createUserConfigLastNameRegexKey: 'Nom de famille non valide',
    createUserConfigLastNameRequiredKey: 'Le nom est obligatoire',
    createUserConfigLastNameLengthKey:
      'La longueur du nom de famille est trop courte, doit être de 2 caractères et plus',
    createUserConfigLastNameLengthKey2:
      'La longueur du nom de famille est trop courte, ne doit pas dépasser 50 caractères',
    createUserConfigMiddleNameLabelKey: 'Deuxième nom',
    createUserConfigMiddleNamePlaceholderKey: 'Deuxième nom',
    createUserConfigMiddleNameRegexKey: 'Deuxième prénom non valide',
    createUserConfigMiddleNameRequiredKey: 'Le deuxième prénom est requis',
    createUserConfigMiddleNameLengthKey:
      'La longueur du deuxième prénom est trop courte, doit être de 2 caractères et plus',
    createUserConfigMiddleNameLengthKey2:
      'deuxième prénom longueur trop longue, ne doit pas dépasser 50 caractères',
    createUserConfigEmailLabelKey: 'Adresse électronique',
    createUserConfigEmailPlaceholderKey: 'Adresse électronique',
    createUserConfigEmailRegexKey: 'Adresse email non valide',
    createUserConfigEmailRequiredKey: 'Adresse e-mail est nécessaire',
    createUserConfigEmailLengthKey:
      "La longueur de l'adresse e-mail est trop courte, doit être de 5 caractères et plus",
    createUserConfigGenderLabelKey: 'Le genre',
    createUserConfigGenderPlaceholderKey: 'Le genre',
    createUserConfigGenderOptionKey1: 'Mâle',
    createUserConfigGenderOptionKey2: 'Femme',
    createUserConfigGenderOptionKey3: 'Ni',
    createUserConfigGenderRequiredKey: 'Le sexe est requis',
    createUserConfigPhoneLabelKey: 'Numéro de téléphone',
    createUserConfigPhonePlaceholderKey: 'Numéro de téléphone',
    createUserConfigPhoneRegexKey: 'Numéro de téléphone non valide',
    createUserConfigPhoneRequiredKey:
      'Votre numéro de téléphone est requis pour la réinitialisation du mot de passe',
    createUserConfigPhoneLengthKey:
      "Le numéro de téléphone n'est pas valide doit contenir 9 chiffres",
    createUserConfigPhoneLengthKey2:
      "Le numéro de téléphone n'est pas valide doit contenir 11 chiffres",
    createUserConfigDateOfBirthLabelKey: 'Date de naissance',
    createUserConfigDateOfBirthPlaceholderKey: 'Date de naissance',
    createUserConfigDateOfBirthRequiredKey:
      'La date de naissance est obligatoire',
    createUserConfigRoleLabelKey: 'Sélectionnez un rôle',
    createUserConfigRolePlaceholderKey: 'Sélectionnez un rôle',
    createUserConfigRoleOptionKey1: 'Administrateur',
    createUserConfigRoleOptionKey2: 'Agent',
    createUserConfigRoleRequiredKey: 'Le rôle est requis',
    createUserConfigMessageLabelKey: "Message d'invitation (Optioal)",
    createUserConfigMessagePlaceholderKey: "Message d'invitation (Optioal)",
    createUserConfigMessageRequiredKey: 'Un message est requis',

    userManagementCreateBtnText: 'Créer un utilisateur',
    userManagementInviteBtnText: 'Invitez des collaborateurs',
    userManagementTitleKey: 'Titre',
    userManagementFirstNameKey: 'Prénom',
    userManagementLastNameKey: 'Nom de famille',
    userManagementMiddleNameKey: 'Deuxième nom',
    userManagementEmailKey: 'E-Mail',
    userManagementGenderKey: 'Le genre',
    userManagementPhoneNumberKey: 'Téléphone',
    userManagementDateOfBirthKey: 'Date de naissance',
    userManagementRoleKey: 'Rôle',
    userManagementColumnText: 'Colonnes',
    userManagementColumnSelect: 'Tout sélectionner',
    userManagementColumnUnselect: 'Tout déselectionner',
    userManagementNavTitle: 'Gestion des utilisateurst',
    userManagementNavActiveText: 'utilisateurs actifs',
    userManagementNavSearchPlaceholder:
      'Rechercher la gestion des utilisateurs',
    userManagementNavSearchArial: 'Chercher',
    userManagementNavShowing: 'Montrant',
    userManagementNavShowingOf: 'de',
    userManagementActiveNavFilterPlaceholder: 'Filtrer par actif type',
    userManagementLockedNavFilterPlaceholder: 'Filtrer par statut type',
    userManagementLockedAccount: 'Ce compte est bloqué',
    userManagementAccountNoEdit: 'Vous ne pouvez pas modifier le rôle',
    userManagementChangeRole: 'Rôles assignés',
    userManageMentRoleDescriptionKey1:
      "Cet utilisateur a accès pour vérifier les identifiants et leurs détenteurs à l'aide de l'application de vérification iDQR",
    userManageMentRoleDescriptionKey2:
      "Cet utilisateur a accès pour vérifier les identifiants et leurs détenteurs à l'aide de l'application de vérification iDQR",
    userManageMentRoleDescriptionKey3:
      "Cet utilisateur a accès pour vérifier les identifiants et leurs détenteurs à l'aide de l'application de vérification iDQR",
    userManagementOptionViewText: 'Voir les détails',
    userManagementOptionEditText: 'Modifier les détails',
    userManagementOptionResetPasswordText: 'Réinitialiser le mot de passe',
    userManagementOptionLockText: "Verrouiller l'utilisateur",
    userManagementOptionUnlockText: "Déverrouiller l'utilisateur",
    userManagementOptionDeactivateText: 'Désactiver',
    userManagementOptionActivateText: 'Activer',

    resetPasswordModalHeading: 'Réinitialiser le mot de passe',
    resetPasswordModalInfoText1: 'Vous êtes sur le point de réinitialiser',
    resetPasswordModalInfoText2:
      'mot de passe. En réinitialisant ce mot de passe, un nouveau mot de passe est généré et envoyé à',
    resetPasswordModalInfoText3: 'e-mail. Voulez-vous continuer?',
    resetPasswordModalSubmitBtn: 'Réinitialiser le mot de passe',
    resetPasswordModalCancelBtn: 'Annuler',

    activateModalActivateText: 'Activer',
    activateModalDeactivateText: 'Désactiver',
    activateModalUserText: 'Utilisatrice',
    activateModalInfoText1: 'Vous êtes sur le point de',
    activateModalInfoText2: 'Voulez-vous continuer?',
    activateModalSubmitBtn: 'Activer',
    activateModalCancelBtn: 'Annuler',

    unlockModalHeading: "Déverrouiller l'utilisateur",
    unlockModalInfoText1: 'Vous êtes sur le point de',
    unlockModalactionText: 'ouvrir',
    unlockModalInfoText2: 'Voulez-vous continuer?',
    unlockModalSubmitBtn: 'Ouvrir',
    unlockModalCancelBtn: 'Annuler',

    viewUserModalDoneBtn: 'Fermer',

    userManagementBulkUploadBtnText: 'Importer des utilisateurs en masse',

    gotAnAccount: 'Vous avez un compte?',
    signinLink: 'Se connecter',
    signupSocialGoogleText: 'Inscrivez-vous avec Google',
    getStarted: 'Commencer',
    getStartedTitle: 'Créez votre compte gratuit sur la base',
    troubleSignupInquiry: 'Des problèmes pour vous inscrire?',
    signupButton: 'Commencer',

    userManagementNavInactiveText: 'utilisateurs inactifs',

    dashboardNavShowing: 'Montrant',
    dashboardNavShowingOf: 'de',

    organisationManagementNavTitle: "Gestion de l'organisation",
    organisationManagementNavSearchPlaceholder:
      "Gestion de l'organisation de recherche",
    organisationManagementNavSearchArial: 'Chercher',
    organisationManagementActiveNavFilterPlaceholder:
      "Filtrer par actif statut d'organisation",
    organisationManagementCreateBtnText: 'Créer une organisation',
    activateModalOrgText: 'Organisation',
    activateOrgModalInfoText1: 'Vous êtes sur le point de',
    activateOrgModalInfoText2:
      "en tant qu'organisation. Es-tu sur de vouloir continuer?",
    optionModalApprove: 'Approuver',
    optionModaldisApprove: 'Désapprouver',
    optionModalContinueApprove: 'Voulez-vous continuer',
    generalOptionEditText: 'Modifier les détails',
    generalOptionViewText: 'Voir les détails',
    generalOptionDeactivateText: 'Désactiver',
    generalOptionActivateText: 'Activer',
    totalOrgText: 'Organisation Totale',
    activeOrgText: 'Organisation Active',
    inactiveOrgText: 'Organisation Inactive',
    orgViewDetailsHeader: "Détails de l'organisation",

    verifyMyOrganisation: 'Vérifier mon organisation',
    proceedBtn: 'Procéder',
    goBackBtn: 'Retourner',
    nextBtn: 'Prochain',
    doneBtn: 'Terminé',

    dashboardNavigationText1: 'Tableau de bord',
    dashboardNavigationText2: 'Modèles',
    dashboardNavigationText3: 'Organisation',
    dashboardNavigationText4: 'Utilisatrice',
    dashboardNavigationText5: 'Générateur de formulaires',
    dashboardNavigationText6: 'Portefeuille',
    dashboardNavigationText7: 'Branches',
    dashboardNavigationText15: 'Payeuse',
    dashboardNavigationText17: 'Paiements',
    dashboardNavigationText18: 'Payer les factures',
    dashboardNavigationText19: 'Approbations',
    userManagementTranslationKey: 'Enregistrements',
    projectManagementTranslationKey: 'Projets',

    unauthoriseHeader: 'Accès non autorisé!',
    unauthoriseParagraph:
      'Vous ne disposez pas du privilège requis pour afficher cette page',
    unauthoriseButtonText: 'Retour à la page précédente',

    dashboardSettingLogout: 'Se déconnecter',
    dashboardSwitchCommunity: 'communauté',
    dashboardJoinCommunity: 'Rejoignez la communauté',

    dashboardSettingText1: 'Aidez-moi',
    dashboardSettingText2: 'Paramètres du compte',

    branchManagementNavTitle: 'Gestion de succursale',
    branchManagementNavSearchPlaceholder:
      'Rechercher dans la gestion des succursales',
    branchManagementNavSearchArial: 'Chercher',
    branchManagementActiveNavFilterPlaceholder:
      'Filtrer par statut actif de branche',
    branchManagementCreateBtnText: 'Créer une branche',

    activateModalBranchText: 'Branche',
    activateBtanchModalInfoText1: 'Vous êtes sur le point de',
    activateBranchModalInfoText2:
      'en tant que succursale. Es-tu sur de vouloir continuer?',
    branchViewDetailsHeader: "Détails de l'organisation",
    branchMetadataNavText: 'Branches',
    branchOptionalHeaderText: 'Utilisatrices',
    branchManagementSubNavSearchPlaceholder:
      "Rechercher à l'aide du nom de la succursale et du responsable",

    generalBackButtonText: 'Retour',

    profileDashboardUserTab: 'Informations personnelles',
    profileDashboardOrganisationTab: "Informations d'affaires",
    profileDashboardSecurityTab: 'Sécurité',
    profileDashboardUserHeader: 'Mettez à jour vos informations personnelles',
    profileDashboardOrganisationHeader:
      'Mettez à jour vos informations commerciales',
    profileDashboardSecurityHeader: 'Mot de passe',
    profileDashboardOTPBtn: 'Changer le mot de passe',
    profileDashboardPasswordHeading:
      'Changez votre mot de passe pour un nouveau',
    profileDashboardBankTab: 'Compte bancaire',
    profileDashboardBankHeader: 'Détails de compte en banque',
    profileDashbaordErrorFetching: 'Erreur lors de la récupération des banques',
    profileDashboardAccountCount: 'Compte bancaire',
    profileDashboardAddAccountBtn: 'Ajouter un compte',
    profileDashboardAccountSetup: "Vous n'avez pas de compte configuré",
    profileDashboardCreateAccount: 'Créer un compte',
    profileDashboardRemoveModalHeading: 'Supprimer le compte bancaire',
    profileDashboardRemoveModaltext: 'Êtes-vous sûr de vouloir désinstaller',
    profileDashboardRemoveModaltextList: 'depuis votre liste de comptes',
    profileDashboardCancelBtn: 'Annuler',
    profileDashboardSubmitBtn: 'Soumettre',
    profileDashboardCreateModalHeading: 'Ajouter un compte',
    profileDashboardEditModalHeading: 'Compte mis à jour',
    profileDashboardCreateModaltext:
      'Entrez les informations du compte bancaire où les revenus seront payés.',
    profileDashboardSelectBank: 'Sélectionnez une banque',
    profileDashboardInputAccountNumber: 'Numéro de compte',
    profileDashboardInputAccountNumberPlaceholder: 'Entrez le numéro de compte',
    profileDashboardSelectPaymentGateway:
      'Sélectionnez la passerelle de paiement préférée',
    profileDashboardCreateAnotherText: 'Créer un autre',
    profileDashboardUpdateBtn: 'Sauvegarder les modifications',
    profileDashbaordAccountNameValidation:
      'La vérification du compte a échoué.',
    profileDashbaordAccountNumberValidation:
      "Le numéro de compte n'est pas valide",
    profileDashbaordAccountVerificationFailed:
      'Nous ne pouvons pas charger la page de création de compte pour le moment. Veuillez réessayer dans 5 minutes',
    'serial-number-key': '#',
    'bank-name-key': 'NOM DE BANQUE',
    'bank-account-number-key': 'NUMÉRO DE COMPTE',
    'bank-account-name-key': 'NOM DU COMPTE',
    'bank-payment-gateway-key': 'PASSERELLE DE PAIEMENT',
    'bank-action-column-key': 'ACTION',
    'edit-action-key': 'Éditer',
    'remove-action-key': 'Retirer',

    supportedDashboardTypeUser: 'Tous les utilisateurs',
    supportedDashboardTypeGroup: 'Groupes',
    userGroupDashboardEmptyStateText:
      'Organisez vos utilisateurs et votre collection en créant des groupes',
    userGroupDashboardEmptyStateBtn: 'Créer un groupe',
    userGroupDashboardCreateMemberError:
      'Les membres du groupe ne peuvent pas être vides',
    userGroupDashboardCreateHeader: "Créer un groupe d'utilisateurs",
    userGroupDashboardEditHeader: "Modifier le groupe d'utilisateurs",
    userGroupDashboardCreateNameInput: 'Nom de groupe',
    userGroupDashboardCreateNameInputError: 'Nom de groupe non valide',
    userGroupDashboardSelectInput: 'Sélectionnez les utilisateurs ',
    userGroupDashboardCreateBtn: 'Créer',
    userGroupDashboardCreateAnotherBtn: 'Créer un autre',
    userGroupDashboardUpdateBtn: 'Sauvegarder les modifications',
    userGroupDashboardViewDetailsModalText: 'Utilisatrices',
    userGroupDashboardViewDetailsModalHeaderName: 'Nom',
    userGroupDashboardViewDetailsModalHeaderEmail: 'Email',
    userGroupDashboardViewDetailsModalRemoveUser: "Supprimer l'utilisateur?",
    userGroupDashboardRemoveModalInfoText1:
      'Vous êtes sur le point de supprimer',
    userGroupDashboardRemoveModalInfoText2: 'de',
    userGroupDashboardRemoveModalInfoText3: 'Es-tu sur de vouloir continuer?',
    userGroupDashboardRemoveBtn: 'Retirer',
    userGroupDashboardActivateHeader: 'Activer le groupe?',
    userGroupDashboardDeactivateHeader: 'Désactiver le groupe?',
    userGroupDashboardActivateModalInfoText1: 'Vous êtes sur le point de ',
    userGroupDashboardActivateModalInfoText2: 'Es-tu sur de vouloir continuer?',

    bulkCreateUserTitle: "Téléchargement groupé de l'utilisateur",
    bulkCreateUserFirstDescPhrase:
      'La création en masse de plusieurs utilisateurs implique',
    bulkCreateUserDownloading: 'téléchargement en cours',
    bulkCreateUserSecondDescPhrase: 'le modèle Excel structuré,',
    bulkCreateUserPopulating: 'peuplement',
    bulkCreateUserThirdDescPhrase:
      'le modèle téléchargé avec les données appropriées, et',
    bulkCreateUserUploading: 'téléchargement',
    bulkCreateUserFourthDescPhrase: 'le modèle Excel terminé.',
    bulkCreateUserRedownload: 'Télécharger à nouveau',
    bulkCreateUserDonwload: 'Télécharger',
    bulkCreateUserStructuredTemplate: 'modèle Excel structuré',
    bulkCreateUserDownloadInitiated: 'Le téléchargement a été lancé',
    bulkCreateUserUploadTemplate: 'Importer un modèle Excel rempli',
    bulkCreateUserFileSizeLimitMessage: 'Fichier trop volumineux.',
    bulkCreateUserFileExtensionMessage:
      'Extension de fichier non prise en charge.',
    bulkCreateUserDelete: 'Supprimez',
    bulkCreateUserNext: 'Prochain',
    bulkCreateUserValidating: 'Validation',
    bulkCreateUserFixErrors:
      'Corrigez toutes les erreurs et remettez en ligne le fichier Excel',
    bulkCreateUserErrors: 'Erreurs',
    bulkCreateUserError: 'Erreur',
    bulkCreateUserDetected: 'Détecté',
    bulkCreateUserReuploadSheet: 'Réimporter la feuille corrigée',
    bulkCreateUserDownloadErrorSheet: "Télécharger la feuille d'erreur",
    bulkCreateUserCancel: 'Résilier',
    bulkCreateUserNoErrors: 'Aucune erreur détectée',
    bulkCreateUserDone: 'Terminé',

    roleManagementTitle: 'Gestion des rôles',
    roleCreateHeader: 'Créer un rôle',
    editRoleHeader: 'Mettre à jour le rôle',
    roleCreateBtn: 'Créer un rôle',
    roleSubmitBtn: 'Soumettre',
    roleSaveChangesBtn: 'Sauvegarder les modifications',
    roleNavActiveText: 'Rôles actifs',
    roleNavInActiveText: 'Rôles inactifs',
    roleCreateAgainBtn: 'Créer à nouveau',
    roleNameHeader: 'Nom de rôle',
    roleDescriptionHeader: 'Description du rôle',
    roleCreatedByHeader: 'Créé par',
    roleActiveStatusHeader: 'Statut actif',
    roleDateCreatedHeader: 'Date créée',
    rolePrivilegeHeader: 'Privilège (s)',
    roleViewDetailsVert: 'Voir les détails',
    roleEditDetailsVert: 'Modifier les détails',
    roleActivateVert: 'Activer',
    roleDeactivateVert: 'Désactiver',
    roleFilterByActiveStatus: 'Filtrer par statut actif',
    roleFilterByOrganisation: 'Filtrer par organisation',
    roleDownloadPlaceHolder: 'Téléchargez la liste des rôles',
    roleSearchPlaceholder: "Rechercher à l'aide du nom du rôle",
    roleInformation: 'Informations sur le rôle',
    roleDateCreated: 'Date créée',
    roleDetails: 'Détails du rôle',
    roleCloseBtn: 'Proche',
    roleSelectPrivilege: 'Sélectionnez le (s) privilège (s)',
    roleSelectCommunity: 'Sélectionnez une communauté',
    roleActivateModalHeaderText: 'ce rôle?',
    roleTotalHeader: 'Rôle(s)',
    roleActivateTextInfoEnd: 'rôle. Es-tu sur de vouloir continuer?',
    roleDescriptionForm: 'Description du rôle (facultatif)',
    roleFilterByCommunity: 'Filtrer par communauté',
    activeText: 'Active',
    inActiveText: 'Inactive',
    allText: 'Toute',
    roleEmptyStateMain: 'Aucun rôle à montrer',
    roleCreateAnother: 'Créer un autre',
    exportAsCSV: 'Exporter au format CSV',
    exportAsExcel: 'Exporter vers Excel',
    downloadRoleList: 'Télécharger sous forme de liste de rôles',
    roleCreateUnableToLoad:
      'Nous ne pouvons pas charger la page de création de rôle pour le moment. Veuillez réessayer dans 5 minutes',

    roleNameError: 'Veuillez saisir le nom de votre rôle',
    rolePrivilegesError: 'Veuillez sélectionner un ou plusieurs privilèges',
    'datepicker-default-caption': 'TOUTE',
    'datepicker-today-caption': "Aujourd'hui",
    'datepicker-yesterday-caption': 'Hier',
    'datepicker-seven-days-caption': 'Les 7 derniers jours',
    'datepicker-thirty-days-caption': 'Les 30 derniers jours',
    'datepicker-last-month-caption': 'Le mois dernier',
    'datepicker-custom-date-caption': 'Gamme personnalisée',
    'datepicker-apply-button': 'Appliquer',
    'datepicker-cancel-button': 'Annuler',

    'showing-text': 'Montrant',
    of: 'de',
    newest: 'Le plus récent',
    oldest: 'Le plus ancien',
    show: 'Montrer',
    entries: 'Entrées',

    roleInitViewMainText:
      "Contrôlez facilement l'accès au compte de votre organisation en créant des rôles et des privilèges",
    roleInitViewSubText:
      'Cliquez sur le bouton ci-dessous pour créer votre premier rôle',

    awMainHeading: 'Créez votre workflow',
    awSubHeading: 'Fournissez des détails qui décrivent votre flux de travail',

    awWorkflowNameLabel: 'Nom du workflow',
    awWorkflowNamePlaceholder: 'Entrez le nom du workflow',
    awWorkflowDescriptionLabel: 'Brève description (facultative)',
    awWorkflowDescriptionPlaceholder: 'Brève description (facultative)',
    awLevelButtonText: 'Niveau',
    awWorkflowTypeHeading: 'Quel type de flux de travail souhaitez-vous créer',

    awSimpleWorkflowType: 'Un flux de travail simple',
    awSimpleWorkflowTootip:
      "Choisissez cette option si vous souhaitez simplement attribuer l'approbation d'une demande à ce niveau à une ou plusieurs personnes",
    awConditionalWorkflowType: 'Un workflow conditionnel',
    awConditionalWorkflowTootip:
      "Choisissez cette option si l'approbation d'une demande à ce niveau dépend d'une condition ou d'un groupe de conditions",

    awValidationForLessAmount: 'Le montant doit être supérieur à',
    awValidationForApprovers: 'Sélectionnez les approbateurs',
    awValidationNoAMount: 'Entrez un montant',
    awValidationInvalidAmount: 'Entrez un montant valide',
    awValidationConditionConflict: 'Conflit de condition',
    awValidationConditionConflictInRange: "est de l'ordre de",
    awValidationConditionConflictConjuction: 'et',
    awValidationForGreaterAmount: 'Le montant doit être inférieur à',
    awValidationForDescription:
      'La longueur du champ doit être comprise entre 4 et 220 caractères',
    awValidationInvalidWorkflowName: 'Le nom du workflow est obligatoire',
    awValidationShortDescriptionValue:
      'La longueur du champ est trop courte, doit contenir 5 caractères et plus',
    awMultiSelectPlaceholderIndividual:
      'sélectionner une ou plusieurs personnes',
    awMultiSelectPlaceholderGroup: 'Sélectionnez un groupe',
    awMultiSelectPlaceholderBranch: "sélectionnez quelqu'un dans la branche",
    awAmountInputHeading: 'Montant',
    awAmountInputLable: 'Ajouter un montant',
    awGreaterThanText: 'Plus que',
    awGreaterOrEqualtext: 'Plus grand ou égal à',
    awLessThanText: 'Moins que',
    awLessOrEqualText: 'Inférieur ou égal à',
    awAddRangeButtonText: 'Ajouter une plage',
    awCancelRangeButtonText: 'Annuler la plage',
    awAddRangeConjustionText: 'ET',
    awWhoShouldApprove: 'Qui devrait approuver?',
    awApproverAsIndividual: 'Personnes',
    awApproverAsGroup: 'Groupes',
    awApproverAsBranch: 'Branche',
    awApproverAsAuto: 'Approuver automatiquement',
    awSingleApprovalText: 'Un seul approbateur doit approuver la demande',
    awMultipleApproverText:
      "Tous affectés en tant qu'approbateur doivent approuver la demande",
    awConditionalFormHeading: 'Condition',
    awIfConditionHeading: 'Si',
    awElseIfConditionHeading: 'Sinon si',
    awElseConditionHeading: 'Autre',
    awAddConditionButtonText: 'Ajouter une condition',
    awNavigationNext: 'Prochain',
    awNavigationPrevious: 'Précédent',
    awAddMoreLevel: 'Ajouter plus de niveau',
    awCancelButtonText: 'Annuler',
    awCreateButtontext: 'Créer',
    awCancelModalHeader: 'Annuler la création du workflow',
    awCancelModalText:
      "Vous êtes sur le point d'annuler ce workflow. Si vous continuez, toutes les informations seront perdues",
    awContinueButtonText: 'Continuer',
    awInitialStateHeading:
      "Créez et définissez votre flux de travail d'approbation",
    awInitialStateSubHeading:
      "Le flux de travail d'approbation vous aide à créer et à gérer diverses activités / processus qui nécessitent une approbation ou une série d'approbations avant qu'une action ne soit entreprise",
    awInitialStateButtonText: "Créer un workflow d'approbation",
    awInitialStateDashboardHeading: 'Gestion des approbations',

    loginConfigSelectType:
      'Connectez-vous avec votre e-mail ou votre numéro de téléphone',
    goBack: 'Retourner',

    otpSubHeaderText:
      'Veuillez saisir le mot de passe à usage unique auquel nous vous avons envoyé',

    dashboardNavigationText8: 'Transaction de portefeuille',
    dashboardNavigationText9: 'Portefeuille manuel',
    dashboardNavigationText10: 'Gestion des factures',
    dashboardNavigationText11: 'Réconciliation',
    dashboardNavigationText12: 'Gestion des types de revenus',
    dashboardNavigationText13: 'Gestion des rôles',
    dashboardNavigationText14: 'Lettre de demande',

    accountSettingHelptext: 'Aidez-moi',
    accountSettingtext: 'Paramètres du compte',
    accountSettingHelpSubtext: 'Préférences de compte et plus',
    accountSettingSubtext: "Service d'aide et de support",
    accountSettingBecomePayer: 'Devenez payeur',

    'reset-password-failed-heading':
      'ÉCHEC DE LA RÉINITIALISATION DU MOT DE PASSE',
    'reset-password-error-goto-login': 'Aller à la connexion',
    'reset-password-invalid-link':
      "Ce lien de vérification par e-mail n'est pas valide",
    'reset-password-expired-link':
      'Le lien de réinitialisation du mot de passe a expiré. Vous pouvez cliquer sur le bouton ci-dessous pour renvoyer un nouveau lien de réinitialisation du mot de passe à votre adresse e-mail',
    'reset-password-error-occured':
      "Une erreur s'est produite lors du traitement de votre demande. Veuillez cliquer sur le lien dans votre boîte de réception pour réessayer",

    fileByPaymentStatusKey: 'Filtrer par statut de paiement',
    idManagementserialHashKey: 'clé de hachage série',
    idManagementPortraitImageKey: 'Image de portrait',
    idManagementFirstNameKey: 'Prénom',
    idManagementLastNameKey: 'Nom de famille',
    idManagementServiceKey: 'Service',
    idManagementRegistrationNumberKey: "Numéro d'enregistrement",
    idManagementPaymentStatusKey: 'Statut de paiement',
    idManagementPrintStatusKey: "État de l'impression",
    idManagementIssueStatusKey: 'État du problème',
    idManagementPrintCountKey: "Nombre d'impressions",
    idManagementExpirationDateKey: 'Expiration Date',
    idManagementDateIssuedKey: "Date d'émission",
    idManagementDateGeneratedKey: "",
    bulkPrintIdCards: "Cartes d'identité à impression en masse",
    bulkIssueIdCards: "Cartes d'émission en vrac",

  },
};
